export const supportedLanguages = [
  'en',
  'de',
  'es',
  'es-mx',
  'fr',
  'it',
  'ja',
  'ko',
  'pl',
  'pt-br',
  'ru',
  'zh-chs',
  'zh-cht',
];

export const unsupported = {
  en: 'The DIM team does not support using this browser. Some or all DIM features may not work.',
  de: 'Das DIM-Team unterstützt diesen Browser nicht. Einige oder alle DIM-Funktionen funktionieren möglicherweise nicht.',
  es: 'El equipo de DIM no soporta usar este navegador. Algunas o todas las características de DIM podrían no funcionar.',
  'es-mx':
    'El equipo de DIM no soporta usar este navegador. Algunas o todas las características de DIM podrían no funcionar.',
  fr: "L'équipe DIM ne prend pas en charge ce navigateur. Certaines ou toutes les fonctionnalités de DIM peuvent ne pas fonctionner.",
  it: "Il team di DIM non supporta l'utilizzo di questo browser. Alcune o tutte le funzioni di DIM potrebbero non funzionare.",
  ja: 'DIM チームはこのブラウザの利用をサポートしていません。DIM の一部または全ての機能が動作しない可能性があります。',
  ko: 'DIM 팀은 이 브라우저를 지원하지 않습니다. DIM의 일부나 전체 기능이 동작하지 않을 수 있습니다.',
  pl: 'Zespół DIM nie obsługuje tej przeglądarki. Niektóre lub wszystkie funkcje DIM mogą nie działać.',
  'pt-br':
    'A equipe do DIM não oferece suporte a este navegador. Alguns recursos do DIM podem não funcionar.',
  ru: 'Команда DIM не поддерживает использование этого браузера. Некоторые или все функции DIM могут не работать.',
  'zh-chs': 'DIM 团队未对当前浏览器作出支持。DIM 可能部分或完全不可用。',
  'zh-cht': 'DIM團隊不支持使用此瀏覽器。 DIM可能部分或完全不可用。',
};

export const steamBrowser = {
  en: 'The Steam overlay browser is very old and some or all DIM features may not work. We cannot provide support for it.',
  de: 'Der Steam-Overlay-Browser ist sehr alt und einige oder alle DIM-Funktionen funktionieren möglicherweise nicht. Wir können dies nicht unterstützen.',
  es: 'El navegador de la interfaz de Steam es muy antiguo y podría hacer que algunas o todas las características de DIM no funcionen. No podemos proveer de soporte para ello.',
  'es-mx':
    'El navegador de Steam es muy antiguo y podría hacer que algunas o todas las características de DIM no funcionen. No podemos proveer de soporte para ello.',
  fr: "Le navigateur de l'overlay Steam est très vieux et certaines des fonctionnalitées de DIM peuvent ne pas fonctionner. Nous ne pouvons pas fournir de support pour ce navigateur.",
  it: "Il browser dell'overlay di Steam è molto vecchio e alcune o tutte le funzionalità di DIM potrebbero non funzionare. Non possiamo fornire supporto.",
  ja: 'Steam オーバーレイ ブラウザは非常に古いため、DIMの一部の機能もしくは全て動作しない可能性があることからサポート対象外とします。',
  ko: '스팀 오버레이의 브라우저는 매우 오래되어 DIM의 일부 혹은 모든 기능이 동작하지 않을 수 있습니다. 이에 대한 지원은 제공되지 않습니다.',
  pl: 'Przeglądarka nakładki Steam jest bardzo stara i część funkcji lub wszystkie funkcje DIM mogą nie działać. Nie możemy zapewnić wsparcia w tym zakresie.',
  'pt-br':
    'O navegador do Painel Steam é muito antigo e alguns recursos do DIM podem não funcionar. Não podemos oferecer suporte para isso.',
  ru: 'Браузер оверлея Steam очень старый, и некоторые или все функции DIM могут не работать. Мы не можем предоставить для него поддержку.',
  'zh-chs':
    'Steam 游戏内叠加浏览器版本较老，DIM 的部分或全部功能可能无法正常工作，且我们无法为其提供支持。',
  'zh-cht': 'Steam覆蓋層的瀏覽器已經非常老了，可能無法使用一些DIM的功能，我們無法提供相關支援。',
};

export const samsungInternet = {
  en: 'Samsung Internet can make sites look too dark when dark mode is on. Enable Settings > Labs > Use website dark theme or switch to another browser.',
  de: 'Samsung Internet kann Websites zu dunkel erscheinen lassen, wenn der dunkle Modus eingeschaltet ist. Einstellungen > Labs > Webseite dunkles Theme verwenden oder wechsle zu einem anderen Browser.',
  es: 'Internet de Samsung puede hacer que los sitios parezcan demasiado oscuros cuando el modo oscuro está activo. Habilita Opciones > Laboratorios > Usar tema oscuro o cambia a otro navegador.',
  'es-mx':
    'El Internet de Samsung puede hacer que los sitios parezcan demasiado oscuros cuando el modo oscuro está activo. Activa Opciones > Laboratorios > Usar tema oscuro o cambia a otro navegador.',
  fr: 'Samsung Internet peut rendre les sites trop sombre quand le mode sombre est activé. Activez Paramètres > Labs > Utiliser le mode sombre du site web ou utilisez un autre navigateur.',
  it: 'Samsung Internet può rendere i siti troppo scuri quando la modalità scura è attiva. Abilita in Impostazioni > Labs > Utilizza tema scuro oppure passa a un altro browser.',
  ja: 'Samsungブラウザでは、ダーク モードがオンになっているとサイトが暗くなりすぎることがあります。ブラウザから 設定 > ラボ > Webサイトのダークテーマを使用 を有効にするか、別のブラウザに切り替えてください。',
  ko: '삼성 인터넷은 다크 모드가 활성화된 경우 사이트를 너무 어둡게 만들 수 있습니다. 설정 > 실험실 > 웹사이트의 다크 테마를 사용하거나 다른 브라우저를 사용하세요.',
  pl: 'Aplikacja Samsung Internet może spowodować, że strony będą wyglądały zbyt ciemno, gdy włączony jest tryb ciemny. Wejdź w i włącz Ustawienia > Labs > Użyj ciemnego motywu witr. WWW lub przełącz się na inną przeglądarkę.',
  'pt-br':
    'O Samsung Internet pode fazer com que alguns sites pareçam muito escuros quando o modo escuro está ativado. Ative Configurações > Labs > Usar tema escuro do site da web ou mude para outro navegador.',
  ru: 'В Samsung Internet сайты могут выглядеть слишком тёмными, когда включен тёмный режим. Включите "Настройки" > "Labs" > "Использовать темную тему сайта" или переключитесь на другой браузер.',
  'zh-chs':
    '启用深色模式时，三星浏览器可能会导致网页显示过于黑暗。在设置 > 通用 > 使用网页深色主题或使用其他浏览器来解决此问题。',
  'zh-cht':
    '當暗黑模式啓用時，三星瀏覽器可能讓頁面顯示過於黑暗。開啓三星瀏覽器的“設定 > 實驗室 > 采用網站的暗黑模式”，或使用另一個瀏覽器。',
};
